import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { useTheme } from "styled-components";
import { TextSpan } from "../Styled/Text";
import Box from "../Styled/Box";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const BadgeBar = props => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(_StyledBox, {
    flex: true,
    column: true,
    styledMargin: "0 15px",
    justifySpaceBetween: true,
    whiteSpace: "nowrap",
    styledMinHeight: "70px",
    verticalCenter: true,
    $_css: theme.darkLighter,
    $_css2: theme.darkLighter,
    children: [/*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsxs(TextSpan, {
        textLight: true,
        uppercase: true,
        overflowHide: true,
        overflowEllipsis: true,
        children: [props.label, " ", props.badge !== undefined ? "(".concat(props.badge, ")") : null]
      })
    }), /*#__PURE__*/_jsx(_StyledBox2, {
      flex: true,
      styledWidth: "100%",
      children: props.children
    })]
  });
};
export default BadgeBar;
var _StyledBox = _styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        border-top: 1px solid ", ";\n        border-bottom: 1px solid ", ";\n        justify-content: space-evenly;\n        align-items: center;\n      "])), p => p.$_css, p => p.$_css2);
var _StyledBox2 = _styled2(Box).withConfig({
  displayName: "BadgeBar___StyledBox2",
  componentId: "sc-1ghvyql-0"
})(["justify-content:space-between;"]);